import React from 'react'
import PropTypes from 'prop-types'

const Arrow = ({ size, x }) => (
  <div
    style={{
      border: `${size}px solid transparent`,
      borderTop: 'none',
      borderBottomColor: 'white',
      position: 'absolute',
      left: x - size,
      boxSizing: 'content-box',
    }}
  />
)

Arrow.propTypes = {
  size: PropTypes.number,
  x: PropTypes.number,
}

export default Arrow
